import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers"
import CategoryHero from "../ones/CategoryHero"
import Footer from "../ones/Footer"
import OneJournal from "../ones/OneJournal"

export default function JournalsLanding() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllJournals(),
    ])
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    const records = appContext.allJournals || [];

    return (
      <>
        <CategoryHero
          eyebrow="MIKA KENYATA JOURNALS"
          title="Read thoughtful work and research."
          description="Discover published journals across the Mika Kenyata marketplace."
        />

        <div className="container marketplace-page-container">
          <h6 className="main-section-title">Journals</h6>
          <div className="row g-4">
            {
              records.length > 0 ?
                records.map((item) => {
                  return (
                    <div className="col-12 col-sm-6 col-lg-4" key={item.uuid}>
                      <OneJournal data={item} />
                    </div>
                  )
                })
                :
                <div className="col-12">
                  <div className="marketplace-empty-state">No journals were found</div>
                </div>
            }
          </div>
        </div>

        <Footer />
      </>
    )
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
